import { render, staticRenderFns } from "./CitaMedica.vue?vue&type=template&id=f6fec02e&scoped=true&"
import script from "./CitaMedica.vue?vue&type=script&lang=js&"
export * from "./CitaMedica.vue?vue&type=script&lang=js&"
import style0 from "./CitaMedica.vue?vue&type=style&index=0&id=f6fec02e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fec02e",
  null
  
)

export default component.exports